import { Children } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../../../utils/theme/godzilla_light";
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../../constants"
import { Trans, useTranslation } from "react-i18next";
import { GradientCard } from "../../components";
import LessionImage1 from '../../../../assets/images/svgs/identifyingGA/lesion_01.png';
import LessionImage2 from '../../../../assets/images/svgs/identifyingGA/lesion_02.png';
import LessionImage3 from '../../../../assets/images/svgs/identifyingGA/lesion_03.png';
import TransMsg from './transMessage';

const styles = {
    imageTag: {
        ...theme.typography.montseratBodyMedium,
        fontSize: "13px",
        color: "#00567C"
    }
}

const LesionAreas = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    const lesionAreasData = {
        title: t(TransMsg.LESION_AREAS_TITLE),
        description: t(TransMsg.LESION_AREAS_DESCRIPTION),
        notes: t(TransMsg.LESION_AREAS_NOTES),
        imageData: [
            {
                "tag": "A",
                "imageUrl": LessionImage1,
                "imageFooter": "Image courtesy of Dr. Mohammad Rafieetary"
            },
            {
                "tag": "B",
                "imageUrl": LessionImage2,
                "imageFooter": " Image courtesy of Dr. Arshad Khanani"
            },
            {
                "tag": "C",
                "imageUrl": LessionImage3,
                "imageFooter": "Image courtesy of Dr. David Lally"
            }
        ]
    }

    return (
        <Box textAlign={"left"} px="31px" py={"65px"} sx={{ backgroundColor: "#fff" }} display="flex" flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
            <Box maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%">
                <Box textAlign={isMobileX ? "center" : "left"}>
                    <Typography sx={{ ...theme.typography.components.sectionTitle }}>
                        {lesionAreasData.title}
                    </Typography>

                    <Typography sx={{ ...theme.typography.components.sectionDescription, mt: "24px" }}>
                        <Trans
                            i18nKey={lesionAreasData.description}
                            components={{ sup: <sup /> }} />
                    </Typography>
                </Box>

                <Box display={"flex"} pt={"24px"} gap={"1rem"} maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} flexWrap={"wrap"} justifyContent={"center"} alignItems={"center"} flex={1}>
                    {Children.toArray(lesionAreasData.imageData.map((items) => {
                        return (
                            <Box >
                                <Typography sx={styles.imageTag}>{items.tag}</Typography>
                                <Box sx={{ overflow: "hidden", mt: "10px" }}>
                                    <img src={items.imageUrl} alt={`${items.tag}-image`} style={{ maxWidth: "275px", maxHeight: "201px" }} />
                                </Box>
                                <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px", fontStyle: "italic" }}>
                                    {items.imageFooter}
                                </Typography>
                            </Box>
                        )
                    }))}
                </Box>
                <GradientCard
                    cardSx={{ maxWidth: EDUCATION_HUB_CONTENT_MAX_WIDTH, mt: "19px", p: isMobileX ? "19px 47px 70px 31px" : "81px 124px 80px 75px" }}
                    contentSx={{ textAlign: "left" }}
                    content={<Trans
                        i18nKey={lesionAreasData.notes}
                        components={{ sup: <sup /> }} />}
                />
            </Box>
        </Box>
    )
}

export default LesionAreas